<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Reefer Trailer Rental</h1>
    	      <p class="lead grey">Rent a Reefer Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Reefer Trailer that fit your transportation needs. Simply request your Reefer Trailer available for short-term rental with PNO Rental.</p>
    				<p><a href="/trailers?category=reefer" class="btn btn-lg btn-success">Search Reefer Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
            <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_reefer.jpg')" class="img-fluid mb-3" alt="Reefer Trailer Rental">
            </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Reefer Trailer Features</h2>
    	<p class="lead grey">Reefer trailers are the most common choice for transportation of goods sensitive to temperature.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">Specification for transportation when driving in Europe.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>New Cool</h5>
    			<p class="grey">New Cool trailer without diesel use and CO2 emission.</p>
    			<br class="d-none d-md-block">
    	  </div>
    	  <div class="col-md-4">
    			<h5>Opening Side</h5>
    			<p class="grey">Opening side for loading of wide goods.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Double Compartment/Stock</h5>
    			<p class="grey">Double compartment and/or double stock for transportation of goods requiring different temperatures or of different types.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>City</h5>
    			<p class="grey">City specification with lift for easy transport in urban environments.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Cooling Unit</h5>
    			<p class="grey">High quality aggregates from Thermo King and Carrier.</p>
    	  </div>
    	</div>
      <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';

export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Reefer Trailer Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Reefer Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_reefer.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
